import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MasterProductsComponent } from './components/master-products/master-products.component';
import { MasterDataManagementComponent } from './components/master-data-management/master-data-management.component';
import { AccessManagementComponent } from './components/access-management/access-management.component';

const routes: Routes = [
  {
    path: 'master',
    component: MasterDataManagementComponent,
  },
  {
    path: 'useraccess',
    component: AccessManagementComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdministrationRoutingModule { }
